/**
 * Controla el grid de tareas.
 */
TareasGridCtrl.$inject = ['$log', '$scope', '$http', 'dialogService', 'Tarea', 'EnvioEntidad', 'OrdenActionsService', 'TareaActionsService', 'IncidenciaActionsService'];

export default function TareasGridCtrl($log, $scope, $http, dialogService, Tarea, EnvioEntidad, OrdenActionsService, TareaActionsService, IncidenciaActionsService) {

    var DIALOG_CAMBIO_TIPO_TEMPLATE = require('./tareasCambioTipoDialog.html');
    var DIALOG_CAMBIO_TIPO_ID = 'dialogCambiaTipoTarea';
    var DIALOG_EDITAR_TAREA_TEMPLATE = require('./editTareaDialog.html');
    var DIALOG_EDITAR_ENTIDAD_ENVIO_TEMPLATE = require('../envios-entidades/addEditEntidadEnvioDialog.html');
    var DIALOG_EDITAR_ENTIDAD_ENVIO_ID = 'dialogAddEditarEntidadEnvio';

    var urlTiposBase = Sigo.var.path + '/obras';
    $scope.mensaje = '';

    $scope.editarOrigenOExpediente = function (incidenciaId, tareaId, tipo) {
        IncidenciaActionsService.editarOrigenOExpediente(incidenciaId, tareaId, tipo);
    };

    $scope.editarServicio72h = function (tareaId, tipo) {
        $log.debug('Editando el servicio de la tarea ' + tareaId + ' ...');
        $log.debug('Tipo ' + tipo);

        Tarea.edit({tareaId: tareaId}, function (data) {
            var botones = {
                botonOk: ucfirst(Lang.get('nombres.editar')),
                botonCancel: ucfirst(Lang.get('nombres.cancelar'))
            };

            doDialog(DIALOG_EDITAR_TAREA_TEMPLATE, data, ucfirst(Lang.get('nombres.editar')) + " " + Lang.choice('nombres.tarea', 1),
                "dialogEditarTarea", botones)
                .then(function (result) {
                    editarTareaServer(tareaId, result)
                });
        }, function (error) {
            Sigo.UI.Messages.open([error.data.messages], 0);
        });
    };

    function editarTareaServer(tareaId, tarea) {
        $log.debug('Editando la tarea ' + tareaId + '...');

        Tarea.update({tareaId: tareaId}, tarea, function (data) {
            $log.debug('Tarea editada!');
            actualizaFilaVTarea(data.vTarea);
        });
    }

    $scope.pausarTarea = function (tareaId, rol) {
        TareaActionsService.pausarTarea(tareaId, rol);
    };

    $scope.finalizarTarea = function (tareaId) {
        TareaActionsService.finalizarTarea(tareaId);
    };

    $scope.rechazarTarea = function (tareaId, rol) {
        TareaActionsService.rechazarTarea(tareaId, rol);
    };

    $scope.marcarComoDuplicadaTarea = function (tareaId) {
        TareaActionsService.marcarComoDuplicada(tareaId);
    };

    $scope.marcarComoRedirigidaTarea = function (tareaId) {
        TareaActionsService.marcarComoRedirigida(tareaId);
    };

    $scope.solicitarCambioTipo = function (tareaId) {
        var titulo = ucfirst(Lang.get('mensajes.confirmacion_cambio_tipo'));

        var botones = {
            botonOk: ucfirst(Lang.choice('nombres.cambio', 1) + ' ' + Lang.choice('nombres.tipo_incidencia', 1)),
            botonCancel: ucfirst(Lang.get('nombres.cancelar'))
        };

        var options = {
            autoOpen: false,
            modal: true,
            title: titulo,
            minWidth: 600
        };

        dialogService.open(DIALOG_CAMBIO_TIPO_ID, DIALOG_CAMBIO_TIPO_TEMPLATE, {id: tareaId}, options, botones)
            .then(function (result) {
                var msg = result.mensaje;
                if (!Sigo.config['comentarios']['estado_modulo'] || (msg != undefined && msg.length > 0)) {
                    solicitarCambioTipo(result);
                } else {
                    Sigo.UI.Messages.open([Lang.get('mensajes.escribir_comentario')], 0);
                }
            });
    };

    $scope.solicitarFechaFinalizacion = function (tareaId, multiple, codigos) {
        TareaActionsService.finalizarTarea(tareaId, multiple, codigos);
    };

    $scope.addEntidadEnvio = function (tareaId) {
        var titulo = ucfirst(Lang.choice('nombres.anyadir', 1) + ' ' + Lang.choice('nombres.entidad', 1)) + ' ' + Lang.choice('nombres.envio', 1);

        var botones = {
            botonOk: titulo,
            botonCancel: ucfirst(Lang.get('nombres.cancelar'))
        };

        var options = {
            autoOpen: false,
            modal: true,
            title: titulo,
            minWidth: 400
        };

        dialogService.open(DIALOG_EDITAR_ENTIDAD_ENVIO_ID, DIALOG_EDITAR_ENTIDAD_ENVIO_TEMPLATE, {tarea_id: tareaId}, options, botones)
            .then(function (result) {
                EnvioEntidad.save(result, function (data) {
                    $log.debug('envioEntidad editada!');
                    $log.debug(data);
                    actualizaFilaVTarea(data.tarea, true);
                });
            });
    };

    $scope.anyadirTareasAOrden = function (codigosTareas) {
        OrdenActionsService.anyadirTareasAOrden(codigosTareas);
    };

    function doDialog(template, model, titulo, extraOptions) {

        var options = {
            autoOpen: false,
            modal: true,
            title: titulo,
            minWidth: 600
        };

        return dialogService.open("dialogRechazarTarea", template, model, options, extraOptions);
    }

    function rechazarTarea(model, tipoRechazar) {
        //console.log(model);
        $http.post(urlTiposBase + '/rechazar-tarea/' + model.id + '/' + tipoRechazar, model)
            .success(function (data) {
                Sigo.UI.Messages.open(data.messages, 0);
                actualizaFilaVTarea(data.tarea, true);
            }).error(function (data) {
            Sigo.UI.Messages.open([data.error.message], 0);
        });
    }

    function marcarComoDuplicada(model) {
        $http.post(urlTiposBase + '/marcar-duplicada/' + model.id, model)
            .success(function (data) {
                Sigo.UI.Messages.open(data.messages, 0);
                actualizaFilaVTarea(data.tarea, true);
            });
    }

    function marcarComoAperturaExp(model) {
        $http.post(urlTiposBase + '/marcar-apertura-expediente/' + model.id, model)
            .success(function (data) {
                Sigo.UI.Messages.open(data.messages, 0);
                actualizaFilaVTarea(data.tarea, true);
            });
    }

    function marcarComoRedirigida(model) {
        $http.post(urlTiposBase + '/marcar-como-redirigida/' + model.id, model)
            .success(function (data) {
                Sigo.UI.Messages.open(data.messages, 0);
                actualizaFilaVTarea(data.tarea, true);
            });
    }

    function solicitarCambioTipo(model) {
        $http.post(urlTiposBase + '/solicitar-cambio-tipo/' + model.id, model)
            .success(function (data) {
                Sigo.UI.Messages.open(data.messages, 0);
                actualizaFilaVTarea(data.tarea, true);
            });
    }
}